import showAlert from '../common/Alert';

type AsyncFunction<T> = () => Promise<T>;

export const handleWithAlert = async <T>(
    fn: AsyncFunction<T>,
    options?: {
        successMessage?: string;
        errorMessage?: string;
        showSuccess?: boolean;
    }
): Promise<T | null> => {
    try {
        const result = await fn();

        if (options?.showSuccess && options.successMessage) {
            showAlert({
                icon: 'success',
                title: 'Success',
                text: options.successMessage,
            });
        }

        return result;
    } catch (error: any) {
        showAlert({
            icon: 'error',
            title: 'Error',
            text: options?.errorMessage || error.message || 'Something went wrong!',
        });
        return null;
    }
};
